import metaverse from "../../assets/startups/metaverse.svg";
import blueballmedia from "../../assets/startups/Blueball Media.svg";
import Eranext from "../../assets/startups/eranexit.svg";
import nxtq from "../../assets/startups/nxtq pvt.svg";
import irvesh from "../../assets/startups/irvesh.svg";
import hummsa from "../../assets/startups/hummsa.svg";
import padmaseetha from "../../assets/startups/padmaseetha.svg";
import clarila from "../../assets/startups/clarila.svg";
import rayd8 from "../../assets/startups/rayd8.svg";
import versanova from "../../assets/startups/versanova.svg";
import arkaAerospace from "../../assets/startups/arka aerospace.svg";
import flomobility from "../../assets/startups/flomobility.svg";
import glibzter from "../../assets/startups/glibzter.svg";
import univigor from "../../assets/startups/univigor.svg";
// new
import Parentheses from "../../assets/startups/Parentheses.svg";
import anantadi from "../../assets/startups/anantadi.svg";
import astromeda from "../../assets/startups/astromeda.svg";
import choira from "../../assets/startups/choira.svg";
import cloudwork from "../../assets/startups/cloudwork.svg";
import contelligenz from "../../assets/startups/contelligenz.svg";
import drona from "../../assets/startups/drona.svg";
import jolyai from "../../assets/startups/jolyai.svg";
import nuralsync from "../../assets/startups/nuralsync.svg";
import photosplmedx from "../../assets/startups/photosplmedx.svg";
import projexel from "../../assets/startups/projexel.svg";
import segritech from "../../assets/startups/segritech.svg";
import sephira from "../../assets/startups/sephira.svg";
import Xtraliving from "../../assets/startups/Xtraliving.svg";

const startupData =[
    {
        "startupName": "Metaverse",
        "startupLogo": metaverse,
    },
    {
        "startupName": "Blueball Media",
        "startupLogo": blueballmedia,
    },
    {
        "startupName": "Eranext Auto Private Limited",
        "startupLogo": Eranext,
    },
    {
        "startupName": "NxtQ Private Limited",
        "startupLogo": nxtq,
    },
    {
        "startupName": "Nirvesh Enterprises",
        "startupLogo": irvesh,
    },
    {
        "startupName": "Hummsa Biotech",
        "startupLogo": hummsa,
    },
    {
        "startupName": "Padmaseetha Technologies",
        "startupLogo": padmaseetha,
    },
    {
        "startupName": "Clarila",
        "startupLogo": clarila,
    },
    {
        "startupName": "RAYD8",
        "startupLogo": rayd8,
    },
    {
        "startupName": "Versanova Innovations",
        "startupLogo": versanova,
    },
    {
        "startupName": "Arka Aerospace",
        "startupLogo": arkaAerospace,
    },
    {
        "startupName": "FLO Mobility Pvt Ltd",
        "startupLogo": flomobility,
    },
    {
        "startupName": "Glibzter",
        "startupLogo": glibzter,
    },
    {
        "startupName": "Univigor Innovative",
        "startupLogo": univigor,
    },
    {
        "startupName": "Parentheses",
        "startupLogo": Parentheses,
    },
    {
        "startupName": "Anantadi",
        "startupLogo": anantadi,
    },
    {
        "startupName": "Astromeda space",
        "startupLogo": astromeda,
    },
    {
        "startupName": "Choira",
        "startupLogo": choira,
    },
    {
        "startupName": "CloudWork",
        "startupLogo": cloudwork,
    },
    {
        "startupName": "Drona Automations",
        "startupLogo": drona,
    },
    {
        "startupName": "Joly AI",
        "startupLogo": jolyai,
    },
    {
        "startupName": "NeuralSync AI",
        "startupLogo": nuralsync,
    },
    {
        "startupName": "Contelligenz",
        "startupLogo": contelligenz,
    },
    {
        "startupName": "Xtraliving",
        "startupLogo": Xtraliving,
    },
    {
        "startupName": "Photospimedx Pvt Ltd",
        "startupLogo": photosplmedx,
    },
    {
        "startupName": "Projexel Technologies",
        "startupLogo": projexel,
    },
    {
        "startupName": "SegriTech",
        "startupLogo": segritech,
    },
    {
        "startupName": "Sephira",
        "startupLogo": sephira,
    }
];

export default startupData;